export default `State,Population
Uttar Pradesh,199812341
Maharashtra,112374333
Bihar,104099452
West Bengal,91276115
Madhya Pradesh,72626809
Tamil Nadu,72147030
Rajasthan,68548437
Karnataka,61095297
Gujarat,60439692
Andhra Pradesh,49577103
Odisha,41974219
Telangana,35003674
Kerala,33406061
Jharkhand,32988134
Assam,31205576
Punjab,27743338
Chhattisgarh,25545198
Haryana,25351462
Uttarakhand,10086292
Himachal Pradesh,6864602
Tripura,3673917
Meghalaya,2966889
Manipur,2570390
Nagaland,1978502
Goa,1458545
Arunachal Pradesh,1383727
Mizoram,1097206
Sikkim,610577
Delhi,16787941
Jammu and Kashmir,12267032
Puducherry,1247953
Chandigarh,1055450
Dadra and Nagar Haveli and Daman and Diu,585764
Andaman and Nicobar Islands,380581
Ladakh,274000
Lakshadweep,64473
India,1210569573`